<div (prepClickOutside)="onClickOutside()" class="toolbar-notifications" role="toolbar"
  aria-label="Notifications toolbar" fxFlex="grow" fxLayout="row" fxLayoutAlign="start center">
  <button role="button" aria-label="Toggle Notifications" (click)="toggleDropdown()" [class.open]="isOpen"
    class="button" fxFlex="grow" mat-button type="button" [matTooltip]="LangTextData.tooltipLabel.toolBoxNotification"
    matTooltipClass="table_tooltip_job_filename" [attr.aria-expanded]="isOpen" matTooltipPosition="below" role="button"
    aria-label="View notifications">
    <mat-icon [matBadgeHidden]="notifyCount === 0" [matBadge]="notifyCount" class="icon">
      notifications_active
    </mat-icon>
  </button>

  <div [class.open]="isOpen" class="dropdown">
    <prep-card>
      <prep-card-header class="dropdown-header">
        <prep-card-header-heading>
          <h2 style="padding: 0;margin: 0;font-size: 1.2rem;">{{LangTextData.htmlLabel.notificationHeading}}</h2>
        </prep-card-header-heading>
        <prep-card-header-subheading style="color: #1976d2;">
          {{LangTextData.htmlLabel.notficationPart1Text}} {{ notifyCount }}
          {{LangTextData.htmlLabel.notificationPart2Text}}
        </prep-card-header-subheading>

        <prep-card-header-subheading *ngIf="notifications.length === 0" style="text-align: center;">
          <span style="color: rgb(33, 33, 33);">
            {{LangTextData.htmlLabel.notificationFineText}}
          </span>
        </prep-card-header-subheading>

      </prep-card-header>

      <prep-card-content class="dropdown-card-content" *ngIf="notifications.length > 0">
        <prep-scrollbar class="dropdown-content">
          <div fxLayout="column">
            <ng-container *ngFor="let notification of notifications; let last = last">
              <div (click)="markAsRead(notification)" [@listFade] [class.read]="notification.read" class="notification"
                fxLayout="row" fxLayoutAlign="start center" matRipple>
                <div class="label" fxLayout="column" [matTooltip]="notification.filename "
                  matTooltipClass="table_tooltip_job_filename" matTooltipPosition="left">
                  <div class="time" style="color: #1976d2;word-wrap: break-word !important">

                    {{
                    notification.filename ?.length > 17
                    ? notification.filename .substring(0, 10) +
                    "...." +
                    notification.filename .substring(notification.filename .length - 7)
                    : notification.filename
                    }}

                  </div>
                  <div class="name" style="word-wrap: break-word !important">{{ notification.desc }}</div>


                </div>
                <span fxFlex></span>
                <button role="button" aria-label="Mark as Read" [matTooltip]="'Mark as Read'"
                  matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below"
                  (click)="dismiss(notification, $event)" mat-icon-button type="button">
                  <mat-icon class="close">done</mat-icon>
                </button>


              </div>
              <mat-divider *ngIf="!last"></mat-divider>
            </ng-container>
          </div>
          <!-- <div tabindex="-1" *ngIf="notifications.length === 0" [@listFade] class="empty">
            {{LangTextData.htmlLabel.notificationFineText}}
          </div> -->
        </prep-scrollbar>
      </prep-card-content>

      <prep-card-actions *ngIf="false" (click)="markAllAsRead()" class="dropdown-footer" matRipple>
        {{LangTextData.htmlLabel.notificationMarkRead}}
      </prep-card-actions>
    </prep-card>
  </div>
</div>